import { CapoPlugin } from "/home/runner/work/getgrain/getgrain/packages/app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];